// i18next-extract-mark-ns-start LandingAds
import { formatNameForURL } from '../services/seoLocalitiesFormatter';

export function getHeaderPhotoItems({
  city, locality, arrondissement, t,
} = {}) {
  if (arrondissement) {
    return [{
      title: t('Vos artisans experts en maroquinerie - {{city}} {{arrondissement}}', { city, arrondissement }),
      subTitle: t('Choisissez l\'expertise en maroquinerie qui vous convient, \n7 jours sur 7'),
      imageAlt: t('Un artisan à {{city}} {{arrondissement}} effectuant une retouche', { city, arrondissement }),
      isBlack: true,
    }];
  }
  if (locality) {
    return [{
      title: t('Vos artisans experts en maroquinerie - {{locality}}', { locality }),
      subTitle: t('Choisissez l\'expertise en maroquinerie qui vous convient, \n7 jours sur 7'),
      imageAlt: t('Un artisan à {{locality}} dans son atelier', { locality }),
      isBlack: true,
    }];
  }
  return [{
    title: t('Vos artisans experts en maroquinerie - {{city}}', { city }),
    subTitle: t('Choisissez l\'expertise en maroquinerie qui vous convient, \n7 jours sur 7'),
    imageAlt: t('Un artisan à {{city}} dans son atelier', { city }),
    isBlack: true,
  }];
}

export function getPosition({ city, locality, arrondissement } = {}) {
  if (arrondissement) return `${city} ${arrondissement}`;
  if (locality) return `${locality}`;
  return `${city}`;
}

export function getFootNoteTitle({
  t, city, locality, arrondissement,
} = {}) {
  return `${t(
    'Pourquoi faire appel à un artisan expert \npour l\'entretien de vos accessoires de maroquinerie à {{position}} ?',
    { position: getPosition({ city, locality, arrondissement }) },
  )}`;
}

export function getBreadCrumb({
  t, city, locality, arrondissement,
} = {}) {
  if (arrondissement) {
    const arrondissement2digits = (`0${arrondissement}`).slice(-2);
    return [
      { name: t('Accueil'), item: '/' },
      { name: t('Maroquinerie'), item: '/maroquinerie/' },
      { name: city, item: `/maroquinerie/${city}/`.toLowerCase() },
      {
        name: `${city} ${arrondissement}`,
        item: `/maroquinerie/${city}/${city}-${arrondissement2digits}/`.toLowerCase(),
      },
    ];
  }
  if (locality) {
    return [
      {
        name: t('Accueil'),
        item: '/',
      },
      {
        name: t('Maroquinerie'),
        item: '/maroquinerie/',
      },
      {
        name: city,
        item: `/maroquinerie/${city}/`.toLowerCase(),
      },
      {
        name: locality,
        item: `/maroquinerie/${city}/${formatNameForURL(locality)}/`.toLowerCase(),
      },
    ];
  }
  return [
    {
      name: t('Accueil'),
      item: '/',
    },
    {
      name: t('Maroquinerie'),
      item: '/maroquinerie',
    },
    {
      name: city,
      item: `/maroquinerie/${city}/`.toLowerCase(),
    },
  ];
}

export function getLeatherGoodsAltTag({
  t, city, locality, arrondissement,
} = {}) {
  if (arrondissement) return t('artisan maroquinier {{city}} {{arrondissement}}', { city, arrondissement });
  if (locality) return t('artisan maroquinier {{locality}}', { locality });
  return t('artisan maroquinier {{city}}', { city });
}

export function getLeatherGoodsAlterationAltTagLocality({
  t, city, locality, arrondissement,
} = {}) {
  if (arrondissement) return t('entretien et reparation maroquinerie {{city}} {{arrondissement}}', { city, arrondissement });
  if (locality) return t('entretien et reparation maroquinerie {{locality}}', { locality });
  return t('entretien et reparation maroquinerie {{city}}', { city });
}

export function getAlterationAltTagMainLanding(slug, t) {
  if (slug === 'HomePageClothesAlteration') return t('retouche vêtement');
  if (slug === 'HomePageCurtainsAlterations') return t('retouche rideaux voilage');
  return t('entretien reparation avec Tilli');
}
